"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// https://stackoverflow.com/a/6000016/196038
var isFunction = function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

var getElementBySelectorOrFunction = function getElementBySelectorOrFunction(target) {
  if (target) {
    if (isFunction(target)) {
      return target();
    }

    if (target.includes("#")) {
      return document.getElementById(target.substring(1));
    }

    var query = document.querySelector(target);
    if (query) {
      return query;
    }

    return null;
  }

  return null;
};

exports.default = getElementBySelectorOrFunction;